import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Card, Table} from 'antd';
import {Link} from 'react-router-dom';
import {ColumnProps} from 'antd/lib/table';

import {GET_STARTERPACKS} from '../../graphql';
import {ListStarterpack, ParsedListStarterpack} from '../../interfaces';

import StarterpackList from './components/StarterpackList';

import './styles.css';

interface Properties {
  regionId: string;
  clubId: string;
}

class StarterpackListWrap extends Component<Properties> {
  render() {
    const {clubId, regionId} = this.props;
    return (
      <Query query={GET_STARTERPACKS} variables={{clubId}}>
        {({loading, error, data: {starterpacks}}: any) => {
          if (loading) {
            return <Card loading={loading} />;
          }

          if (error) {
            return `Error! ${error.message}`;
          }

          const dataSource: Array<ParsedListStarterpack> = starterpacks.map((starterpack: ListStarterpack, key: number) => ({
            key,
            code: starterpack.externalStarterPackId,
            active: starterpack.active,
            ospAvailable: starterpack.ospAvailable,
            dspAvailable: starterpack.dspAvailable,
            isDefault: starterpack.isDefault,
            priority: starterpack.priority,
            price: starterpack.price,
            title: starterpack.title,
          }));

          const columns: Array<ColumnProps<ParsedListStarterpack>> = [
            {
              title: 'code',
              dataIndex: 'code',
              key: 'code',
              render: (id: String) => <Link to={`/starterpacks/${regionId}/${clubId}/${id}`}>{id}</Link>,
            },
            {
              title: 'title',
              dataIndex: 'title',
              key: 'title',
            },
            {
              title: 'price',
              dataIndex: 'price',
              key: 'price',
              render: (price: string) => price || '-',
            },
            {
              title: 'active',
              dataIndex: 'active',
              key: 'active',
              render: (active: Boolean) => (active ? 'yes' : 'no'),
            },
            {
              title: 'OSP / DSP',
              dataIndex: 'ospAvailable',
              key: 'ospAvailable',
              render: (ospAvailable: boolean, record: any) => {
                return `${ospAvailable ? 'yes' : 'no'} / ${record.dspAvailable ? 'yes' : 'no'}`;
              },
            },
            {
              title: 'priority',
              dataIndex: 'priority',
              key: 'priority',
            },
            {
              title: 'Set to Default',
              dataIndex: 'isDefault',
              key: 'isDefault',
              render: (isDefault: Boolean) => (isDefault ? 'yes' : 'no'),
            },
          ];

          return <StarterpackList dataSource={dataSource} columns={columns} />;
        }}
      </Query>
    );
  }
}

export default StarterpackListWrap;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackList/StarterpackListWrap.tsx